export default {
  'bonus.templateName': '模版名称',
  'bonus.operationTime': '操作时间',
  'bonus.operation': '操作',
  'bonus.unredeemed': '未兑换',
  'bonus.redeemed': '已兑换',
  'bonus.expired': '已过期',
  'bonus.reversed': '已冲销',
  'bonus.exchangeCode': '兑换码',
  'bonus.cash': '现金',
  'bonus.language': '语言',
  'bonus.redirectLink': '跳转链接',
  'bonus.bonusId': '奖金ID',
  'bonus.lobbyId': '大厅ID',
  'bonus.roomId': '房间ID',
  'bonus.accountId': '账号ID',
  'bonus.bonusType': '奖金类型',
  'bonus.redemptionCode': '兑换码',
  'bonus.amount': '金额',
  'bonus.createTime': '创建时间',
  'bonus.redemptionCodeExpiryTime': '兑换码过期时间',
  'bonus.redemptionTime': '兑换时间',
  'bonus.bonusStatus': '奖金状态',
  'bonus.action': '操作',
  'bonus.changeStatus': '更改状态',
  'bonus.batchUpdateStatus': '批量更新状态',
  'bonus.selectAtLeastOneRecord': '需要勾选至少1笔记录',
  'bonus.selectOperation': '请选择操作',
  'bonus.pleaseSelect': '请选择',
  'bonus.bonusInquiry': '奖金列表',
};
